module.exports = __webpack_public_path__ + "static/media/birds@2x.94069f16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/birds@2x.png
// module id = 1854
// module chunks = 43